import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
import IconBase, { IconProps } from '../IconBase';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const IconLikeHeartActive16 = (baseProps: IconProps, ref: Ref<SVGSVGElement>) => {
  return <IconBase {...baseProps}>
        {({
      title,
      titleId,
      ...props
    }: Partial<React.SVGProps<SVGSVGElement>> & SVGRProps) => <svg width={18} height={16} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fillRule="evenodd" clipRule="evenodd" d="M5.66155 1.76221C3.02467 1.76221 0.821234 3.82311 0.809948 6.48716C0.721281 8.12169 1.58601 9.70751 2.89278 10.6366L7.96297 14.3082L8.01082 14.343C8.18135 14.4677 8.40179 14.6289 8.6601 14.6951C8.88254 14.752 9.11574 14.752 9.33818 14.6951C9.59649 14.6289 9.81694 14.4677 9.98746 14.343L10.0353 14.3082L15.1055 10.6366C16.4107 9.70873 17.2815 8.1998 17.1877 6.47561C17.0893 3.83844 14.9108 1.76221 12.3368 1.76221C11.0051 1.76221 9.88765 2.3299 9.03044 3.11668C8.16325 2.26097 6.96808 1.76221 5.66155 1.76221Z" fill="currentColor" /></svg>}
      </IconBase>;
}; // This explicit type declaration prevents TypeScript from expanding IconProps into a huge Pick type
const ForwardRef: React.ForwardRefExoticComponent<IconProps & React.RefAttributes<SVGSVGElement>> = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return IconLikeHeartActive16(props, ref);
});
export default ForwardRef;